import { Button } from '@breetometer/components';
import { DropdownWrapper } from 'BreetComponents';
import type { RefObject } from 'react';

import { type ITooltip, normalizePlacement } from './Tooltip.helpers';

export const Tooltip = ({ children, tipElement }: ITooltip) => (
	<DropdownWrapper>
		{({ controlRef, dropdownRef, handleVisibility, visible, tipPlacement }) => (
			<Button
				variant='native'
				className='tooltip button-cancel-transform'
				onMouseEnter={handleVisibility}
				onMouseLeave={handleVisibility}
				type='button'
				ref={controlRef as RefObject<HTMLButtonElement>}
			>
				{children}
				{visible && (
					<div
						className={`tooltipelement bg-primary-400 border-primary-400 dropdownshadow${normalizePlacement(tipPlacement)}`}
						ref={dropdownRef}
					>
						{tipElement}
					</div>
				)}
			</Button>
		)}
	</DropdownWrapper>
);
